import React, { useState } from "react";
import "../../styles/PagesStyles/Technologies.css";
import openaiIcon from "../../assets/images/Technology/openai.png";
import mistralIcon from "../../assets/images/Technology/mistral.png";
import customIcon from "../../assets/images/Technology/custom.png";
import llamaIcon from "../../assets/images/Technology/llama.png";
import tech1 from "../../assets/images/Technology/agentic.png";
import tech2 from "../../assets/images/Technology/analysis.png";
import tech3 from "../../assets/images/Technology/database.png";
import tech4 from "../../assets/images/Technology/openai.png";
import tech5 from "../../assets/images/Technology/mistral.png";
import multi1 from "../../assets/images/Technology/text.png";
import multi2 from "../../assets/images/Technology/filesearch.png";
import multi3 from "../../assets/images/Technology/understand.png";
import multi4 from "../../assets/images/Technology/cad.png"; 
import visualIcon from "../../assets/images/Technology/document.png";

import backendIcon from "../../assets/images/Technology/backend.png";
import frontendIcon from "../../assets/images/Technology/frontend.png";
import databaseIcon from "../../assets/images/Technology/database.png";
import infraIcon from "../../assets/images/Technology/infra.png";
import gatewayIcon from "../../assets/images/Technology/shield.png";

import versioningIcon from "../../assets/images/Technology/versioning.png";
import gate from "../../assets/images/Technology/gateway.png";

import modelIcon from "../../assets/images/Technology/model.png";
import agentIcon from "../../assets/images/Technology/framework.png";
  import usePageTitle from "../../hooks/usePageTitle";


// import from "../../assets/images/Technology/TechnologyBackground.jpg";
const Technologies = () => {

  usePageTitle("Combat Solutions AI | Technologies");

    const [activeTab, setActiveTab] = useState("ml");

  const techData = {
    ml: [
      {
        icon: openaiIcon,
        title: "OpenAI",
        desc: "Via Azure AI Foundry",
      },
      {
        icon: mistralIcon,
        title: "Mistral",
        desc: "High-performance models",
      },
      {
        icon: customIcon,
        title: "Custom Models",
        desc: "Custom Models",
      },
      {
        icon: llamaIcon,
        title: "Meta LLaMA",
        desc: "Open-source foundation",
      },
    ],
    techniques: [
      {
        icon: tech1,
        title: "Generative AI",
        desc: "Content creation at scale",
      },
      {
        icon: tech3,
        title: "Retrieval-Augmented Generation",
        desc: "Controlled model lifecycle",
      },
      {
        icon: tech2,
        title: "Agentic AI",
        desc: "Safe & compliant AI",
      },
       {
        icon: tech4,
        title: "Prompt Engineering & Optimization",
        desc: "Controlled model lifecycle",
      },
       {
        icon: tech5,
        title: "Fine-tuning & Domain Adaptation",
        desc: "Controlled model lifecycle",
      }
    ],

    multimodal: [
      {
        icon: multi1,
        title: "Text Intelligence",
        desc: "Multimodal reasoning",
      },
      {
        icon: multi2,
        title: "Document Intelligence",
        desc: "Unstructured data handling",
      },
      {
        icon: multi3,
        title: "Image & Visual Understanding",
        desc: "Unified AI access layer",
      },
       {
        icon: multi4,
        title: "Engineering Drawings & CAD Analysis",
        desc: "Engineering design intelligence",
      }
    ],
  };


 return (
  <section className="technology-stack">
    {/* ================= HERO ================= */}
    <section className="tech-hero">
      <div className="hero-content-wrapper">
        <div className="hero-text">
          <h1>Technology Stack Overview</h1>
          <p>
            Our technology ecosystem is designed for scalable, secure, and
            production-ready AI systems.
          </p>
        </div>
        
        {/* TABS */}
        <div className="ai-tech-tags">
          <button
            className={activeTab === "ml" ? "active" : ""}
            onClick={() => setActiveTab("ml")}
          >
            AI & Machine Learning
          </button>

          <button
            className={activeTab === "techniques" ? "active" : ""}
            onClick={() => setActiveTab("techniques")}
          >
            AI Techniques
          </button>

          <button
            className={activeTab === "multimodal" ? "active" : ""}
            onClick={() => setActiveTab("multimodal")}
          >
            Multimodal AI
          </button>
        </div>
      </div>
    </section>
      {/* ================= CONTENT ================= */}
      <section className="tech-content">
        <div>
        <div className="tech-grid">
          {techData[activeTab].map((item, index) => (
            <div className="tech-card" key={index}>
              <img src={item.icon} alt={item.title} />
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
          </div>
        </div>
      </section>

 <div className="section-separator">
        <div className="separator-line"></div>
      </div>

  {/* ================= AI PLATFORMS ================= */}
<section className="ai-platforms-section">
  {/* Heading */}
  <div className="ai-platforms-header">
    <h2>AI Platforms & Infrastructure</h2>
    <p>Enterprise-grade deployment and orchestration</p>
  </div>

  {/* Cards Wrapper */}
  <div className="ai-platforms-cards">
    {/* 1st CARD */}
    <div className="ai-platform-card">
      <h3>
        <span className="card-icon">
          <img src={modelIcon} alt="Model Platforms Icon" />
        </span>
        Model Platforms
      </h3>

      <ul>
        <li>Managed LLM platforms (Azure AI Foundry, AWS Bedrock, SageMaker)</li>
        <li>Self-hosted GPU/TPU clusters for cost & data control</li>
        <li>Support for open-source ML frameworks (PyTorch, TensorFlow, JAX)</li>
        <li>Fine-tuning, inference optimization, and model versioning</li>
      </ul>
    </div>

    {/* 2nd CARD */}
    <div className="ai-platform-card">
      <h3>
        <span className="card-icon">
          <img src={agentIcon} alt="Agent Frameworks Icon" />
        </span>
        Agent Frameworks
      </h3>

      <ul>
        <li>Agent-to-Agent (A2A) communication and task delegation</li>
        <li>Model Context Protocol (MCP) for shared memory and state handling</li>
        <li>Human-in-the-loop interfaces via AG-UI</li>
        <li>Tool calling, workflow chaining, and policy enforcement</li>

      </ul>
    </div>

     {/* 3 rd CARD */}
    <div className="ai-platform-card">
      <h3>
        <span className="card-icon">
          <img src={multi4} alt="Model Platforms Icon" />
        </span>
        Data & Knowledge Management
      </h3>

      <ul>
        <li>Hybrid cloud and on-premise data storage integration</li>
        <li>Vector databases for semantic and similarity search</li>
        <li>Scalable data pipelines for structured/unstructured data</li>
        <li>Automated data labeling, cleaning, and feature extraction</li>

      </ul>
    </div>

    {/* 4th CARD */}
    <div className="ai-platform-card">
      <h3>
        <span className="card-icon">
          <img src={visualIcon} alt="Agent Frameworks Icon" />
        </span>
        Monitoring & Orchestration
      </h3>

      <ul>
        <li>Model performance tracking and experiment management</li>
        <li>Containerized deployment using Docker and Kubernetes</li>
        <li>Real-time logging, metrics, and alerting systems</li>
        <li>CI/CD pipelines for model rollout, rollback, and governance</li>


      </ul>
    </div>
  </div>
</section>

 <div className="section-separator">
        <div className="separator-line"></div>
      </div>

{/*-----------------Engineering Stack----------------*/}
  <section className="engineering-stack-section">
  <div className="engineering-stack-header">
    <h2>Engineering Stack</h2>
  </div>

  <div className="engineering-stack-grid">
    {/* Backend */}
    <div className="engineering-card ">
      <h3>
        <img src={backendIcon} alt="Backend" />
        Backend
      </h3>
      <ul>
        <li>Python, FastAPI, Django, Flask</li>
        <li>Node.js</li>
        <li>Microservices architecture</li>
      </ul>
    </div>

    {/* Frontend */}
    <div className="engineering-card">
      <h3>
        <img src={frontendIcon} alt="Frontend" />
        Frontend
      </h3>
      <ul>
        <li>JavaScript, React, Next.js</li>
        <li>TypeScript</li>
        <li>Tailwind CSS</li>
      </ul>
    </div>

    {/* Databases */}
    <div className="engineering-card">
      <h3>
        <img src={databaseIcon} alt="Databases" />
        Databases & Storage
      </h3>
      <ul>
        <li>PostgreSQL, MySQL, MongoDB</li>
        <li>Vector Databases</li>
        <li>Object storage for documents</li>
      </ul>
    </div>

    {/* Infrastructure */}
    <div className="engineering-card">
      <h3>
        <img src={infraIcon} alt="Infrastructure" />
        Infrastructure
      </h3>
      <ul>
        <li>Docker, Kubernetes</li>
        <li>CI/CD pipelines</li>
        <li>Cloud-native deployments</li>
      </ul>
    </div>

    {/* API Gateways */}
    <div className="engineering-card">
      <h3>
        <img src={gatewayIcon} alt="API Gateway" />
        Secure API Gateways
      </h3>
      <ul>
        <li>Authentication & authorization</li>
        <li>Rate limiting & throttling</li>
        <li>Compliance-ready architecture</li>
      </ul>
    </div>

     {/* AI/ML Intelligences */}
    <div className="engineering-card">
      <h3>
        <img src={tech4} alt="AI/ML" />
        AI / ML & Intelligence
      </h3>
      <ul>
        <li>Large Language Models</li>
        <li>RAG & Vector Search</li>
        <li>AI Agents, Workflow, and Tool Calling</li>
      </ul>
    </div>
  </div>
  </section>
    

    <section className="governance-section">
      {/* Header */}
      <div className="governance-header">
        <h2>Governance, Security & Control</h2>
        <p>Enterprise-grade security and compliance</p>
      </div>

      {/* Cards */}
      <div className="governance-grid">
        <div className="governance-card">
          <img src={gatewayIcon} alt="RBAC" />
          <h3>Role-based Access Control</h3>
          <p>RBAC for secure resource management</p>
        </div>

        <div className="governance-card">
          <img src={versioningIcon} alt="Model Versioning" />
          <h3>Model Versioning</h3>
          <p>Version control & rollback capabilities</p>
        </div>

        <div className="governance-card">
          <img src={multi2} alt="Audit Logs" />
          <h3>Audit Logs</h3>
          <p>Complete traceability & explainability</p>
        </div>

        <div className="governance-card">
          <img src={gate} alt="Secure API Gateways" />
          <h3>Secure API Gateways</h3>
          <p>Compliance-ready architecture</p>
        </div>
      </div>
    </section>


<section className="integrations-section">
  <h2 className="integrations-title">Integrations</h2>

  {/* ================= DESKTOP VIEW ================= */}
  <div className="integrations-container desktop-view">
    <div className="integration-pill">ERP Systems</div>
    <div className="integration-pill">CRM Platforms</div>
    <div className="integration-pill">Databases & Data Warehouses</div>
    <div className="integration-pill">Messaging & Workflow Tools</div>
    <div className="integration-pill">Email Integration</div>
    <div className="integration-pill">SMS & WhatsApp</div>
    <div className="integration-pill">Telephony (Twilio)</div>
    <div className="integration-pill">Enterprise SSO</div>
    <div className="integration-pill">Cloud Storage</div>
    <div className="integration-pill">Document Management</div>
    <div className="integration-pill">Business Intelligence</div>
    <div className="integration-pill">Custom APIs</div>
  </div>

  {/* ================= MOBILE AUTO SCROLL ================= */}
  <div className="integrations-container mobile-view">
    <div className="integrations-track">
      {/* original */}
      <div className="integration-pill">ERP Systems</div>
      <div className="integration-pill">CRM Platforms</div>
      <div className="integration-pill">Databases & Data Warehouses</div>
      <div className="integration-pill">Messaging & Workflow Tools</div>
      <div className="integration-pill">Email Integration</div>
      <div className="integration-pill">SMS & WhatsApp</div>
      <div className="integration-pill">Telephony (Twilio)</div>
      <div className="integration-pill">Enterprise SSO</div>
      <div className="integration-pill">Cloud Storage</div>
      <div className="integration-pill">Document Management</div>
      <div className="integration-pill">Business Intelligence</div>
      <div className="integration-pill">Custom APIs</div>

      {/* duplicate for seamless loop */}
      <div className="integration-pill">ERP Systems</div>
      <div className="integration-pill">CRM Platforms</div>
      <div className="integration-pill">Databases & Data Warehouses</div>
      <div className="integration-pill">Messaging & Workflow Tools</div>
      <div className="integration-pill">Email Integration</div>
      <div className="integration-pill">SMS & WhatsApp</div>
      <div className="integration-pill">Telephony (Twilio)</div>
      <div className="integration-pill">Enterprise SSO</div>
      <div className="integration-pill">Cloud Storage</div>
      <div className="integration-pill">Document Management</div>
      <div className="integration-pill">Business Intelligence</div>
      <div className="integration-pill">Custom APIs</div>
    </div>
  </div>
</section>


 <section className="future-section">
      {/* Header */}
      <div className="future-header">
        <h2>Built for the Future</h2>
      </div>

      {/* Cards */}
      <div className="future-grid">
        <div className="future-card">
          <img src={customIcon} alt="Rapid Experimentation" />
          <h3>Rapid Experimentation</h3>
          <p>Move from concept to production quickly</p>
        </div>

        <div className="future-card">
          <img src={gatewayIcon} alt="Secure Enterprise Deployments" />
          <h3>Secure Enterprise Deployments</h3>
          <p>Built with security at the core</p>
        </div>

        <div className="future-card">
          <img src={tech1} alt="Scalable AI Systems" />
          <h3>Scalable AI Systems</h3>
          <p>Grow from prototype to enterprise scale</p>
        </div>

        <div className="future-card">
          <img src={backendIcon} alt="Long-term Maintainability" />
          <h3>Long-term Maintainability</h3>
          <p>Clean architecture that stands the test of time</p>
        </div>
      </div>
    </section>

  </section>
  );
};
export default Technologies; 